import { IStoreState } from '../index'
import { DRAWER_WIDTH, COMPACT_DRAWER_WIDTH } from './types'
// Import the remCalc function
const remCalc = (value: number): string => `${value / 16}rem`

// Basic selectors
export const getDrawerActive = (state: IStoreState) => state.drawer.drawerActive
export const getDrawerCompact = (state: IStoreState) =>
  state.drawer.drawerCompact
export const getDisplayMode = (state: IStoreState) => state.drawer.displayMode
export const getIsMobile = (state: IStoreState) => state.drawer.isMobile
export const getForceHideNav = (state: IStoreState) => state.drawer.forceHideNav

// Derived selector for calculating secondary drawer presence
export const getSecondaryDrawerPresent = (state: IStoreState) => {
  const displayMode = getDisplayMode(state)
  return ['expandedWithSecondary', 'compact'].includes(displayMode)
}

// Selector for calculating padding based on drawer state
export const getDrawerPadding = (state: IStoreState) => {
  const drawerActive = getDrawerActive(state)
  const drawerCompact = getDrawerCompact(state)
  const secondaryDrawerPresent = getSecondaryDrawerPresent(state)
  const isMobile = getIsMobile(state)

  // For mobile, don't apply padding
  if (isMobile) {
    return undefined
  }

  // Calculate padding based on drawer state
  if (drawerActive) {
    if (secondaryDrawerPresent) {
      return drawerCompact
        ? remCalc(DRAWER_WIDTH + COMPACT_DRAWER_WIDTH)
        : remCalc(DRAWER_WIDTH * 2)
    } else {
      return remCalc(DRAWER_WIDTH)
    }
  }

  if (secondaryDrawerPresent) {
    return remCalc(DRAWER_WIDTH)
  }

  return 0
}
